/**
 * Returns `true` if a date value is included within a date range; i.e. exactly the same as the
 * start date or end date, or somewhere in between the two.
 * @param dateValue a Date to check against the date range
 * @param dateRange a DateRange to test with. If the date falls within this range, returns `true`.
 */
export const isInDateRange = (
    dateValue: Date,
    dateRange: DateRange,
): boolean => {
    if (dateValue >= dateRange.start && dateValue <= dateRange.end) {
        return true;
    }

    return false;
};
